export default "__VITE_ASSET__CDXbD3Qk__"